import { Box, Flex, Heading, Button } from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { FiArrowLeft } from 'react-icons/fi';

export const CreditAgreementsViewTemplate = ({
  children,
  disableSelectors,
}: {
  children: React.ReactNode;
  disableSelectors: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Flex justify="space-between" width="100%">
        <Heading marginBottom="70px" display="inline-block">
          Credit Agreement Configuration
        </Heading>
        <Box>
          <CreditFacilitySelect isDisabled={disableSelectors} />
          {disableSelectors && (
            <Flex justify="flex-end" alignItems="center" mt="10px" mb="10px">
              <Button
                onClick={() => navigate(-1)}
                marginLeft={3}
                rightIcon={<FiArrowLeft />}
                aria-label="back"
              >
                Back
              </Button>
            </Flex>
          )}
        </Box>
      </Flex>
      {children}
    </Box>
  );
};
